import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { AppShell } from './components/AppShell';
import { LoginPage } from './pages/LoginPage';
import { RunDetailPage } from './pages/RunDetailPage';
import { RunFormPage } from './pages/RunFormPage';
import { AdminSettingsPage } from './pages/AdminSettingsPage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { DocumentationPage } from './pages/DocumentationPage';
import { ProfilePage } from './pages/ProfilePage';
import { ReportExportsPage } from './pages/ReportExportsPage';
import { RunsListPage } from './pages/RunsListPage';

function ProtectedShell() {
  const { user, ready } = useAuth();
  if (!ready) {
    return <div className="flex h-full items-center justify-center text-text-tertiary">Загрузка…</div>;
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<RunsListPage />} />
        <Route path="/exports" element={<ReportExportsPage />} />
        <Route path="/runs/new" element={<RunFormPage />} />
        <Route path="/runs/:runId" element={<RunDetailPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/settings" element={<AdminSettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/documentation/user" element={<DocumentationPage slug="user" />} />
      <Route path="/documentation/developers" element={<DocumentationPage slug="developers" />} />
      <Route path="/*" element={<ProtectedShell />} />
    </Routes>
  );
}
